/**
 * list of parameters
 * @param {is visa checkout authorization enabled for site} enabled
 * @param {visa checkout apikey} apikey
 * @param {visa checkout api domain} visaApiDomain
 * @param {api method for authorize customer} apiAuthRequest
 */
var VisaCheckout = (function ($) {

	function getVisaCheckoutReadyFunc(apiKey, success, error, cancel, $ready) {
		return function () {
			V.on("payment.success", success || function() {});
			V.on("payment.cancel", cancel || function () { });
			V.on("payment.error", error || function () { });
			$ready.resolve(V);
		};
	}

	function VisaCheckout(options) {
		this.enabled = options.enabled;
		this.apikey = options.apikey;
		this.visaApiDomain = options.visaApiDomain.replace(/\/$/, '');
		this.success = options.success;
		this.error = options.error;
		this.cancel = options.cancel;

		this.resizeButton = options.resizeButton;

		this.totals = options.totals;
		this.currencyCode = options.currencyCode;

		this.prePayment = options.prePayment;

		this.$ready = new $.Deferred();

		this._init();
	}

	VisaCheckout.prototype =
	{
		_init: function () {
			if (this.enabled) {
                visa_checkout_instance.init(this.visaApiDomain, getVisaCheckoutReadyFunc(this.apikey, this.success, this.error, this.cancel, this.$ready));
			}
		},

		initVisa: function () {
			var apikey = this.apikey;
			var totals = this.totals;
			var currencyCode = this.currencyCode;
			this.$ready.done(function (v) {
				v.init({
					apikey: apikey,
					paymentRequest: {
						currencyCode: currencyCode,
						total: totals.TotalWithSelect
					},
					settings: {
						shipping: {
							collectShipping: false
						},
						review: {
							message: "Merchant defined message",
							buttonAction: "Pay"
						}
					}
				});
			});
		},

		prePayment: function() {
			return new $.Deferred().promise();
		},

		updateTotals: function (totals) {
			this.totals = totals;
			this.initVisa();
		} 
	}

	return VisaCheckout;

})(jQuery);
